import "../../../css/layout/sidebar.css";
import arrow from '../../../resources/icons/sidebar/arrow.png';

const SidebarRowArrow = ({isClicked}) => {
    var arrowAngle = null;
        if(isClicked){arrowAngle= "90deg";}
        else{arrowAngle= "0deg";}
    return(

        <img src={arrow} alt="Arrow" className='sidebar-arrow-image' style={{rotate: arrowAngle}} />
    );
}

export default SidebarRowArrow;
